// pages/Devices/deviceqrmodal.jsx
import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const DeviceQRModal = ({ isOpen, onClose, device }) => {
  const qrCodeRef = useRef(null);

  // Prepare QR code data (matching Vue's format)
  const getQRData = () => {
    if (!device) return '';
    
    const qrData = {
      sno: device.sno || '',
      devId: device.handsetId || device.devId || '',
      cbid: device.deviceId || '',
      calibrationdate: device.calibrationDate || new Date().toLocaleString(),
      status: device.status || 'NotAssigned',
      dealerName: device.dealer || ''
    };
    
    return JSON.stringify(qrData);
  };

  // Handle print - converts canvas to image for printing
  const handlePrint = () => {
    const canvas = qrCodeRef.current?.querySelector('canvas');
    if (!canvas) {
      alert('QR code not ready. Please try again.');
      return;
    }
    
    const qrImageUrl = canvas.toDataURL('image/png');
    
    const printWindow = window.open('', '_blank', 'width=600,height=600');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>QR Code - ${device?.sno || 'Device'}</title>
          <style>
            body {
              font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              margin: 0;
              padding: 20px;
            }
            .print-container {
              text-align: center;
              width: 100%;
              max-width: 400px;
              margin: 0 auto;
            }
            .qr-image {
              margin: 20px auto;
              text-align: center;
            }
            .qr-image img {
              border: 2px solid #006E6E;
              border-radius: 12px;
              padding: 10px;
              width: 200px;
              height: 200px;
            }
            .device-info {
              margin-top: 20px;
              text-align: left;
              border-top: 1px solid #ddd;
              padding-top: 15px;
            }
            .device-info p {
              margin: 8px 0;
              font-size: 12px;
            }
            .title {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 20px;
              color: #006E6E;
            }
          </style>
        </head>
        <body>
          <div class="print-container">
            <div class="title">Device QR Code</div>
            <div class="qr-image">
              <img src="${qrImageUrl}" alt="QR Code" />
            </div>
            <div class="device-info">
              <p><strong>SNO:</strong> ${device?.sno || ''}</p>
              <p><strong>Device ID:</strong> ${device?.handsetId || device?.devId || ''}</p>
              <p><strong>Control Board:</strong> ${device?.deviceId || ''}</p>
              <p><strong>Status:</strong> ${device?.status || ''}</p>
              <p><strong>Dealer:</strong> ${device?.dealer || ''}</p>
              <p><strong>Generated:</strong> ${new Date().toLocaleString()}</p>
            </div>
          </div>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  if (!isOpen || !device) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="qr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Generate QR Code</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="qr-modal-body">
          <div className="qr-print-container" ref={qrCodeRef}>
            <div className="qr-code-wrapper">
              <QRCodeCanvas
                value={getQRData()}
                size={200}
                level="H"
                includeMargin={true}
              />
            </div>
            <div className="qr-device-info">
              <p><strong>SNO:</strong> {device.sno}</p>
              <p><strong>Device ID:</strong> {device.handsetId || device.devId}</p>
              <p><strong>Control Board:</strong> {device.deviceId}</p>
              <p><strong>Status:</strong> {device.status}</p>
              <p><strong>Dealer:</strong> {device.dealer}</p>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          {/* <button className="print-btn" onClick={handlePrint}>
            🖨️ Print QR
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default DeviceQRModal;
